import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false

import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';
import fabric from 'fabric'
Vue.prototype.axios = axios;
axios.defaults.baseURL='/api'
Vue.use(Vant)
new Vue({
	axios,
	render: h => h(App),
}).$mount('#app')
